import Cast from 'scratch-vm/src/util/cast';

class CIPSoundBlock {
    constructor() {
        this.soundOptions = {
            DO: {
                name: '도 C(48)',
                command: 0x62
            },
            RE: {
                name: '레 D(50)',
                command: 0x56
            },
            MI: {
                name: '미 E(52)',
                command: 0x50
            },
            FA: {
                name: '파 F(53)',
                command: 0x47
            },
            SOL: {
                name: '솔 G(55)',
                command: 0x42
            },
            LA: {
                name: '라 A(57)',
                command: 0x37
            },
            SI: {
                name: '시 B(59)',
                command: 0x33
            },
            DO2: {
                name: '도 C(60)',
                command: 0x1b
            },

            A_DO: {
                name: '도 C(48)',
                command: 0x62
            },
            DO_48: {
                name: '도 C(48)',
                command: 0x62
            },
            A_DO_S: {
                name: '도# C#(49)',
                command: 0x60
            },
            DO_49: {
                name: '도# C#(49)',
                command: 0x60
            },
            A_RE: {
                name: '레 D(50)',
                command: 0x56
            },
            RE_50: {
                name: '레 D(50)',
                command: 0x56
            },
            A_MI_B: {
                name: '미b Eb(51)',
                command: 0x54
            },
            MI_51: {
                name: '미b Eb(51)',
                command: 0x54
            },
            A_MI: {
                name: '미 E(52)',
                command: 0x50
            },
            MI_52: {
                name: '미 E(52)',
                command: 0x50
            },
            A_FA: {
                name: '파 F(53)',
                command: 0x47
            },
            FA_53: {
                name: '파 F(53)',
                command: 0x47
            },
            A_FA_S: {
                name: '파# F#(54)',
                command: 0x44
            },
            FA_54: {
                name: '파# F#(54)',
                command: 0x44
            },
            A_SOL: {
                name: '솔 G(55)',
                command: 0x42
            },
            SOL_55: {
                name: '솔 G(55)',
                command: 0x42
            },
            A_SOL_S: {
                name: '솔# G#(56)',
                command: 0x40
            },
            SOL_56: {
                name: '솔# G#(56)',
                command: 0x40
            },
            A_LA: {
                name: '라 A(57)',
                command: 0x37
            },
            RA_57: {
                name: '라 A(57)',
                command: 0x37
            },
            A_SI_B: {
                name: '시b Bb(58)',
                command: 0x35
            },
            SI_58: {
                name: '시b Bb(58)',
                command: 0x35
            },
            A_SI: {
                name: '시 B(59)',
                command: 0x33
            },
            SI_59: {
                name: '시 B(59)',
                command: 0x33
            },
            B_DO: {
                name: '도 C(60)',
                command: 0x1b
            },
            DO_60: {
                name: '도 C(60)',
                command: 0x1b
            },
            B_DO_S: {
                name: '도# C#(61)',
                command: 0x30
            },
            DO_61: {
                name: '도# C#(61)',
                command: 0x30
            },
            B_RE: {
                name: '레 D(62)',
                command: 0x19
            },
            RE_62: {
                name: '레 D(62)',
                command: 0x19
            },
            B_MI_B: {
                name: '미b Eb(63)',
                command: 0x27
            },
            MI_63: {
                name: '미b Eb(63)',
                command: 0x27
            },
            B_MI: {
                name: '미 E(64)',
                command: 0x17
            },
            MI_64: {
                name: '미 E(64)',
                command: 0x17
            },
            B_FA: {
                name: '파 F(65)',
                command: 0x15
            },
            FA_65: {
                name: '파 F(65)',
                command: 0x15
            },
            B_FA_S: {
                name: '파# F#(66)',
                command: 0x22
            },
            FA_66: {
                name: '파# F#(66)',
                command: 0x22
            },
            B_SOL: {
                name: '솔 G(67)',
                command: 0x13
            },
            SOL_67: {
                name: '솔 G(67)',
                command: 0x13
            },
            B_SOL_S: {
                name: '솔# G#(68)',
                command: 0x20
            },
            SOL_68: {
                name: '솔# G#(68)',
                command: 0x20
            },
            B_LA: {
                name: '라 A(69)',
                command: 0x11
            },
            RA_69: {
                name: '라 A(69)',
                command: 0x11
            },
            B_SI_B: {
                name: '시b Bb(70)',
                command: 0x18
            },
            SI_70: {
                name: '시b Bb(70)',
                command: 0x18
            },
            B_SI: {
                name: '시 B(71)',
                command: 0x0f
            },
            SI_71: {
                name: '시 B(71)',
                command: 0x0f
            },
            C_DO: {
                name: '도 C(72)',
                command: 0x0d
            },
            DO_72: {
                name: '도 C(72)',
                command: 0x0d
            },
            C_RE: {
                name: '레 D(74)',
                command: 0x95
            },
            RE_74: {
                name: '레 D(74)',
                command: 0x95
            },
            C_MI: {
                name: '미 E(76)',
                command: 0x93
            },
            MI_76: {
                name: '미 E(76)',
                command: 0x93
            },
            C_FA: {
                name: '파 F(77)',
                command: 0x12
            },
            FA_77: {
                name: '파 F(77)',
                command: 0x12
            },
            C_SOL: {
                name: '솔 G(79)',
                command: 0x91
            },
            SOL_79: {
                name: '솔 G(79)',
                command: 0x91
            },
            C_LA: {
                name: '라 A(81)',
                command: 0x10
            },
            RA_81: {
                name: '라 A(81)',
                command: 0x10
            },
            C_SI: {
                name: '시 B(83)',
                command: 0x09
            },
            SI_83: {
                name: '시 B(83)',
                command: 0x09
            },
            D_DO: {
                name: '도 C(84)',
                command: 0x08
            },
            DO_84: {
                name: '도 C(84)',
                command: 0x08
            },
            ERROR: {
                name: '에러',
                command: 0x00
            },
            SMALL_EFFECT: {
                name: '작은 효과',
                command: 0x02
            },
            WARNING: {
                name: '경고',
                command: 0x03
            },
            LIGHT: {
                name: '경쾌한',
                command: 0x04
            },
            BASIC: {
                name: '기본',
                command: 0x05
            },
            GREAT_EFFECT: {
                name: '큰 효과',
                command: 0x06
            },
        };
    }

    async soundControl(soundBlock, param) {
        if (!soundBlock) {
            return {
                result: false,
                error: '[Error] The sound block is not connected.',
            };
        }

        const soundOption = this.soundOptions[param];
        if (!soundOption) {
            return {
                result: false,
                error: '[Error] x',
            };
        }
        console.log(soundOption);

        if (soundBlock?.playNote) {
            soundBlock.playNote(soundOption?.command);
        }

        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, 200);
        });
    }

    async soundBeatControl (soundBlock, param, time) {
        if (!soundBlock) {
            return {
                result: false,
                error: '[Error] The sound block is not connected.',
            };
        }

        const soundOption = this.soundOptions[param];
        if (!soundOption) {
            return {
                result: false,
                error: '[Error] x',
            };
        }

        const sec = Cast.toNumber(time) * 1000;
        if (soundBlock?.playNote) {
            const SETINTERVAL = setInterval(
                () => {
                    soundBlock.playNote(soundOption?.command);
                },
                50
            );
            setTimeout(() => {
                clearInterval(SETINTERVAL);
            }, sec);

            return new Promise(resolve => {
                setTimeout(() => {
                    clearInterval(SETINTERVAL);
                    resolve();
                }, sec + 150);
            });
        } else {
            return new Promise(resolve => {
                setTimeout(() => {
                    resolve();
                }, 200);
            });
        }
    }
}

export default CIPSoundBlock;
